/**
 * Tiny rolling-buffer sparkline.
 *
 * Renders SVG path from a value buffer (max ~60 datapoints).
 * Uses linear interpolation, with an area fill underneath the line.
 */
export class Sparkline {
  constructor(svgEl, opts = {}) {
    this.el = svgEl;
    this.max = opts.max ?? 60;
    this.points = [];
    this.minScale = opts.minScale ?? 1;
  }

  push(value) {
    this.points.push(Number(value) || 0);
    if (this.points.length > this.max) this.points.shift();
    this.render();
  }

  reset() {
    this.points = [];
    this.render();
  }

  render() {
    const w = this.el.clientWidth || 200;
    const h = this.el.clientHeight || 32;
    const pts = this.points;
    if (pts.length < 2) {
      this.el.innerHTML = '';
      return;
    }
    const max = Math.max(...pts, this.minScale);
    const dx = w / Math.max(this.max - 1, 1);
    const offset = this.max - pts.length;   // align right
    let line = '';
    for (let i = 0; i < pts.length; i++) {
      const x = (i + offset) * dx;
      const y = h - (pts[i] / max) * (h - 4) - 2;
      line += `${i === 0 ? 'M' : 'L'}${x.toFixed(1)},${y.toFixed(1)} `;
    }
    const lastX = (pts.length - 1 + offset) * dx;
    const firstX = offset * dx;
    const area = line + `L${lastX.toFixed(1)},${h} L${firstX.toFixed(1)},${h} Z`;
    this.el.setAttribute('viewBox', `0 0 ${w} ${h}`);
    this.el.setAttribute('preserveAspectRatio', 'none');
    this.el.innerHTML = `<path class="area" d="${area}"></path><path d="${line}"></path>`;
  }
}
